export const onDatePickerToggle = ({ $scope }) => {
  const isDatePickerClosed = !(
    $scope.selectedRange.dateUpdated.isOpen ||
    $scope.selectedRange.dateCreated.isOpen
  );
  if (isDatePickerClosed && !$scope.isFetchingResults) {
    $scope.getSentReferralList();
  }
};
